export interface StatusChipsProps {
  readonly label: string;
  readonly status: 'error' | 'info' | 'inherit' | 'primary' | 'success' | 'warning';
  readonly componentsClassNames?: Partial<Record<'container', string>>;
}
